// @ts-strict-ignore
import {
	Apstag,
	Audigent,
	CcpaSignalPayload,
	communicationService,
	context,
	DataWarehouseTracker,
	DiProcess,
	GdprConsentPayload,
	PartnerPipeline,
} from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
import {
	AD_ENGINE_CONSENT_UPDATE,
	AD_ENGINE_PARTNERS_READY,
	AD_ENGINE_STACK_START,
} from '../../../communication/events/events-ad-engine';
import { NoAdsDetector } from '../services/no-ads-detector';

@Injectable()
export class NoAdsMode implements DiProcess {
	constructor(
		private pipeline: PartnerPipeline,
		private noAdsDetector: NoAdsDetector,
		private audigent: Audigent,
		private dwTracker: DataWarehouseTracker,
	) {}

	execute(): void {
		this.removeAdSlotsPlaceholders();
		this.noAdsDetector.addReasons(window.ads.context?.opts?.noAdsReasons ?? []);
		const reasons = this.noAdsDetector.getReasons();

		const cityId = window.mw?.config?.get('wgCityId');
		const articleId = window.mw?.config?.get('wgArticleId');

		if (reasons.length) {
			this.dwTracker.track({
				event_type: 'no_ads',
				label: reasons.join(','),
				category: 'no_ads',
				c: cityId,
				a: articleId,
			});
		}

		if (reasons.includes('blacklisted_word')) {
			this.dwTracker.track({
				event_type: 'blacklisted_word',
				label: 'blacklisted_word',
				category: 'blacklisted_word',
				c: cityId,
				a: articleId,
			});
		}

		if (context.get('state.isLogged')) {
			const apstag = Apstag.make();
			apstag
				.init()
				.then(() =>
					communicationService.on(
						AD_ENGINE_CONSENT_UPDATE,
						(consents: GdprConsentPayload & CcpaSignalPayload) =>
							apstag.sendHEM(apstag.getRecord(), consents),
						false,
					),
				);
		}

		this.pipeline
			.add(this.audigent)
			.execute()
			.then(() => {
				communicationService.emit(AD_ENGINE_PARTNERS_READY);
				communicationService.emit(AD_ENGINE_STACK_START);
			});
	}

	private removeAdSlotsPlaceholders(): void {
		const placeholders = document.querySelectorAll(
			'.top-ads-container, .ad-slot-placeholder, .bottom-ads-container',
		);
		placeholders.forEach((placeholder) => {
			placeholder.remove();
		});
	}
}
